import { Record } from "immutable";

const defaults = {
  application: "okta" as TIdentityProviderApplication,
  createdAt: new Date(0),
  id: "",
  metadataUrl: "",
  updatedAt: new Date(0),
};

type TIdentityProviderApplication = "okta";

export class IdentityProviderModel extends Record<typeof defaults>(defaults) {
  static fromServerData(data: unknown) {
    const { application, createdAt, id, metadataUrl, updatedAt } = data as typeof defaults;
    return new IdentityProviderModel({
      application,
      createdAt: new Date(createdAt),
      id,
      metadataUrl,
      updatedAt: new Date(updatedAt),
    });
  }
}
